import { render, staticRenderFns } from "./invInfo.vue?vue&type=template&id=617be236"
import script from "./invInfo.vue?vue&type=script&lang=js"
export * from "./invInfo.vue?vue&type=script&lang=js"
import style0 from "./invInfo.vue?vue&type=style&index=0&id=617be236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports